import React, { useEffect } from 'react';
import {
    Box,
    Container,
    Stack,
    Typography,
    useMediaQuery,
} from '@mui/material';
import UserRole from '../../../shared/AuthRoles';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Earnings } from '../../components/HostPayments/ReservationEarnings';

export const EarningsPage = () => {
    const loggedInUser = UserRole();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`);
        }
    }, []);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const projected = searchParams.get('projected') === 'true';

    return (
        <Stack
            sx={{
                width: '100%',
                // height: isMobile ? '50%' : '80%',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                }}
            >
                <Typography variant='h1'>
                    {projected
                        ? 'Future Possible Earnings'
                        : 'Reservation Earnings'}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingTop: '10px',
                    }}
                >
                    Get a clear overview of your{' '}
                    {projected ? 'future possible' : ''} earnings{' '}
                    {projected ? 'based on current approved reservations' : ''}{' '}
                    from all your listed experiences, right at your fingertips!
                </Typography>
            </Box>
            <Earnings />
        </Stack>
    );
};
